import React, { useState, useEffect, useContext } from 'react';
import InputLogin from '../../inputs/InputLogin'
import Switch from '../../switch/Switch'
import UploadPDF from '../../inputs/UploadPDF'
import UploadImage from '../../inputs/UploadImage'

import SearchableSelect from '../../select/SearchableSelect'
import SelectPhone from '../../select/selectPhone'
import ButtonBack from '../../button/ButtonBack'
import ButtonNext from '../../button/ButtonWhite'
import StatusVerification from '../StatusVerification'
import CopyNotification from "../../banners/CopyNotification";

import { ReactComponent as COPY } from '../../../assets/IconsColurs/IconsGeneral/copy.svg'

import { ReactComponent as BACK } from '../../../assets/IconsColurs/IconsGeneral/chevronLeft.svg'
import { ReactComponent as NEXT } from '../../../assets/IconsColurs/IconsGeneral/chevronRight.svg'
import ButtonTransparent from '../../button/ButtonTransparent';
import BecomeButton from '../../button/BecomeButton'
import CryptoJS from "crypto-js";

import { UtilContext } from "../../../context/UtilContext";
import { GLOBAL_LANGUAGE } from "../../../language/language";

import { formatPhoneNumber } from '../../../utils/FormatPhoneNumber'


const Step3 = ({
  timer,
  onClick,
  copyToClipboard,
  becomeData,
  LevelKYC,
  documentLegal,
  setdocumentLegal,
  BecomeDataStatysFetch,
  documentTypeLegal, setdocumentTypeLegal,
  documentNumberLegal, setdocumentNumberLegal,
  nameLegal, setameLegal,
  lastNameLegal, setlastNameLegal,
  countryLegalName, setcountryLegalName,
  domicileState, setdomicileState,
  domicileCity, setdomicileCity,
  domicileAddress, setdomicileAddress,
  domicileDetail, setdomicileDetail,
  emailLegalAgent, setemailLegalAgent,
  phoneLegalAgent, setphoneLegalAgent,
  isPep, setisPep,
  publicCharge, setpublicCharge,
  detailCharge, setdetailCharge,
  ListCountry,
  documentPP, setdocumentPP,
  phoneLegalAgentCode, setphoneLegalAgentCode,
  managepublicResource, setmanagepublicResource,
  LoadingKYC, id, name,
  documentsSteP3, setdocumentsSteP3,
  errorMesagge,
  LoadingBack,
  /* MANEJO DE ERRORES */
  error,
  documentTypeLegalError,
  documentNumberLegalError,
  nameLegalError,
  lastNameLegalError,
  countryLegalNameError,
  domicileStateError,
  domicileCityError,
  domicileAddressError,
  domicileDetailError,
  emailLegalAgentError,
  phoneLegalAgentError,
  phoneLegalAgentCodeError,
  documentPPError,
  isPepError,
  publicChargeError,
  detailChargeError,
  managepublicResourceError,
  documentsSteP3Error,
  onClickBack,
  copied,
  loading,
  LoadingLayouts
}) => {
  const secretKey = process.env.REACT_APP_HASH;
  const [PEP, setPEP] = useState(false)
  const [isReady, setIsReady] = useState(false);


  const [isEmailValid, setIsEmailValid] = useState(true);
  const [IDFinal, setIDFinal] = useState("");

  const [isSubmitPressed, setIsSubmitPressed] = useState(false);
  const [email, setEmailValue] = useState("");

  const { language } = useContext(UtilContext); // Usa el contexto de Auth

  const handlePhoneChange = (value) => {
    const formatted = formatPhoneNumber(value);

    // Validación específica para Colombia (+57) - debe tener exactamente 10 dígitos
    if (phoneLegalAgentCode === '+57') {
      const numericValue = formatted.replace(/\D/g, "");
      if (numericValue.length > 10) {
        // Si excede 10 dígitos, truncar a 10 dígitos
        const truncatedValue = numericValue.substring(0, 10);
        const truncatedFormatted = formatPhoneNumber(truncatedValue);
        setphoneLegalAgent(truncatedFormatted);
        return;
      }
    }

    // Permitir escribir mientras se está digitando
    setphoneLegalAgent(formatted);
  };

  const handleEmailChange = (value) => {
    setEmailValue(value);
    setemailLegalAgent(value);
  };

  useEffect(() => {
    if (id) {
      const encryptedId = CryptoJS.AES.encrypt(id.toString(), secretKey).toString();

      // Convertir a Base64 seguro para URL
      const urlSafeEncryptedId = encryptedId
        .replace(/\+/g, '-') // Reemplaza '+' con '-'
        .replace(/\//g, '_') // Reemplaza '/' con '_'
        .replace(/=+$/, ''); // Elimina '=' al final


      setIDFinal(urlSafeEncryptedId)
    }
  }, [id])

  useEffect(() => {
    if (
      !LoadingLayouts

    ) {
      setIsReady(true)
    }
  }, [
    LoadingLayouts
  ]);

  if (!isReady) {
    return <div className="flex md:flex-row flex-wrap p-4 w-full" >
      <div className="w-full" >
        <div style={{ height: "50vh", }} className='flex items-center justify-center'>
          <div className="h-20  w-20 flex">
            <div className="spinner-border-white-full animate-spin w-14 h-14 border-4 border-white border-t-transparent rounded-full"></div>

          </div>
        </div>
      </div>
    </div>

  }

  return (
    <div className="w-full h-fit pb-16 gap-4 flex flex-col">
      <div className="space-y-6">
        <div>
          <p className="text-2xl mt-8" style={{ fontFamily: "brico" }}>{GLOBAL_LANGUAGE[language].steps3.title}</p>
          {language !== 'es' && <p className='text-[#E4E4E4]'>{GLOBAL_LANGUAGE[language].steps2.description}</p>}
        </div>

        <CopyNotification show={copied} />

        <div className='space-y-4'>
          <div className='flex flex-col md:flex-row gap-4'>
            <div className='w-full md:w-1/2'>
              <p className='text-sm text-[#B7B7B9]'>{GLOBAL_LANGUAGE[language].steps3.name_legal_representative}</p>
              <InputLogin onChange={setameLegal} value={nameLegal} error={nameLegalError} placeholder={GLOBAL_LANGUAGE[language].steps3.name_legal_representative_placeholder} />
            </div>
            <div className='w-full md:w-1/2'>
              <p className='text-sm text-[#B7B7B9]'>{GLOBAL_LANGUAGE[language].steps3.last_name_legal_representative}</p>
              <InputLogin onChange={setlastNameLegal} value={lastNameLegal} error={lastNameLegalError} placeholder={GLOBAL_LANGUAGE[language].steps3.name_legal_representative_placeholder} />
            </div>
          </div>

          <div className='flex flex-col md:flex-row gap-4'>
            <div className='w-full md:w-1/2'>
              <p className='text-sm text-[#B7B7B9]'>{GLOBAL_LANGUAGE[language].steps3.num_identification}</p>
              <InputLogin onChange={setdocumentNumberLegal} value={documentNumberLegal} error={documentNumberLegalError} placeholder={GLOBAL_LANGUAGE[language].steps3.num_identification_placeholder} />
            </div>
            <div className='w-full md:w-1/2'>
              <p className='text-sm text-[#B7B7B9]'>{GLOBAL_LANGUAGE[language].steps3.country_of_domicile}</p>
              <SearchableSelect image setSelectOpcion={setcountryLegalName} list={ListCountry} error={countryLegalNameError} placeholder={'Escriba el Estado'} label={countryLegalName} />
            </div>
          </div>

          <div className='flex flex-col md:flex-row gap-4'>
            <div className='w-full md:w-1/2'>
              <p className='text-sm text-[#B7B7B9]'>{GLOBAL_LANGUAGE[language].steps3.state_of_domicile}</p>
              <InputLogin onChange={setdomicileState} value={domicileState} error={domicileStateError} placeholder={GLOBAL_LANGUAGE[language].steps3.state_of_domicile_placeholder} />
            </div>
            <div className='w-full md:w-1/2'>
              <p className='text-sm text-[#B7B7B9]'>{GLOBAL_LANGUAGE[language].steps3.city_of_domicile}</p>
              <InputLogin onChange={setdomicileCity} value={domicileCity} error={domicileCityError} placeholder={GLOBAL_LANGUAGE[language].steps3.city_of_domicile_placeholder} />
            </div>
          </div>

          <div>
            <p className='text-sm text-[#B7B7B9]'>{GLOBAL_LANGUAGE[language].steps3.address_of_domicile}</p>
            <InputLogin onChange={setdomicileAddress} value={domicileAddress} error={domicileAddressError} placeholder={GLOBAL_LANGUAGE[language].steps3.address_of_domicile_placeholder} />
          </div>

          <div>
            <p className='text-sm text-[#B7B7B9]'>{GLOBAL_LANGUAGE[language].steps3.address_details}</p>
            <InputLogin onChange={setdomicileDetail} value={domicileDetail} error={domicileDetailError} placeholder={GLOBAL_LANGUAGE[language].steps3.address_details_placeholder} />
          </div>

          <div className='flex flex-col md:flex-row gap-4'>
            <div className='w-full md:w-1/2'>
              <p className='text-sm text-[#B7B7B9]'>{GLOBAL_LANGUAGE[language].steps3.phone}</p>
              <div className='flex gap-2'>
                <SelectPhone setValue={setphoneLegalAgentCode} error={phoneLegalAgentError} />
                <InputLogin onChange={handlePhoneChange} value={phoneLegalAgent} error={phoneLegalAgentError} placeholder={GLOBAL_LANGUAGE[language].steps3.phone_placeholder} className="flex-1" />
              </div>
            </div>
            <div className='w-full md:w-1/2'>
              <p className='text-sm text-[#B7B7B9]'>{GLOBAL_LANGUAGE[language].steps3.email}</p>
              <InputLogin value={emailLegalAgent} onChange={handleEmailChange} error={!isEmailValid ? "Por favor ingrese un correo electrónico válido." : emailLegalAgentError} placeholder={GLOBAL_LANGUAGE[language].steps3.email_placeholder} />
            </div>
          </div>

          <div>
            <p className='text-sm text-[#B7B7B9]'>{GLOBAL_LANGUAGE[language].documents.legal_representative_passport}</p>
            <UploadPDF setUploadedFile={setdocumentPP} uploadedFile={documentPP} error={documentPPError} />
          </div>
        </div>

        <div className='w-full bg-[#5E5E63] h-[1px]'></div>

        <div className='flex flex-row gap-4 items-center'>
          <p>{GLOBAL_LANGUAGE[language].steps3.politically_exposed_person}</p>
          <Switch setValue={setisPep} value={isPep} />
        </div>

        {isPep && (
          <div className='space-y-4'>
            <div>
              <p className='text-sm text-[#E4E4E4]'>{GLOBAL_LANGUAGE[language].steps3.politically_exposed_person_carge}</p>
              <InputLogin onChange={setpublicCharge} value={publicCharge} error={publicChargeError} placeholder={GLOBAL_LANGUAGE[language].steps3.placeholder_public} />
            </div>
            <div>
              <p className='text-sm text-[#B7B7B9]'>{GLOBAL_LANGUAGE[language].steps3.politically_exposed_person_description}</p>
              <InputLogin onChange={setdetailCharge} value={detailCharge} error={detailChargeError} placeholder={GLOBAL_LANGUAGE[language].steps3.placeholder_detail} />
            </div>
            <div className='flex flex-row justify-between items-center border-y border-zinc-700 h-10 px-4'>
              <p>{GLOBAL_LANGUAGE[language].steps3.manage_public_resources}</p>
              <Switch value={managepublicResource} setValue={setmanagepublicResource} />
            </div>
          </div>
        )}

        <div className='w-full bg-[#5E5E63] h-[1px]'></div>

        <div>
          <p className='text-[16px]'>{GLOBAL_LANGUAGE[language].steps3.title_verify}</p>
          <p className='text-[#B7B7B9]'>{GLOBAL_LANGUAGE[language].steps3.description_verify}</p>
        </div>

        <div className='space-y-4'>
          {becomeData && LevelKYC != null && LevelKYC != 5 && LevelKYC != 1 && !LoadingKYC && (
            <div className='flex flex-col md:flex-row gap-3'>
              <BecomeButton BecomeDataStatysFetch={BecomeDataStatysFetch} token={becomeData.token} userId={becomeData.user_id} contractId={becomeData.contract_id} />
              <ButtonTransparent onClick={() => copyToClipboard(`${window.location.origin}/verification-user/${IDFinal}?name=${name}`)} label={GLOBAL_LANGUAGE[language].steps3.share_link} Icon={COPY} iconPosition={"left"} />
            </div>
          )}

          {LevelKYC != 0 && LevelKYC != null && !LoadingKYC && (
            <StatusVerification status={LevelKYC} />
          )}
        </div>

        <div className='w-full bg-[#5E5E63] h-[1px]'></div>

        {LevelKYC !== 5 && !LoadingKYC && (
          <p className="text-sm text-[#B7B7B9]">
            En <span className="text-white inline-block w-[2ch] text-center">{timer}</span> segundos se realizará una nueva consulta para verificar si hubo cambios en el estado.
            {GLOBAL_LANGUAGE[language].steps3.cosas}
          </p>
        )}

        {errorMesagge && (
          <div className="w-full">
            <p className="text-[#FF928B] text-[16px]">{errorMesagge}</p>
          </div>
        )}

        <div className='flex flex-col-reverse md:flex-row justify-between gap-4'>
          <ButtonBack label={GLOBAL_LANGUAGE[language].steps3.label_button_back} Icon={BACK} onClick={onClickBack} loading={LoadingBack} className="w-full md:w-auto" />
          <ButtonNext label={GLOBAL_LANGUAGE[language].steps3.label_button_next} Icon={NEXT} onClick={onClick} loading={loading} className="w-full md:w-auto" />
        </div>
      </div>
    </div>
  );
};

export default Step3;

